import _extends from 'babel-runtime/helpers/extends';

import { crmExamineStepAPI } from '@/api/examine';
import { oaCreateExamineFlowAPI } from '@/api/oa/examine';

import { XhUserCell } from '@/components/CreateCom';
import Nzhcn from 'nzh/cn';

export default {
  name: 'CreateExamineInfo',
  components: {
    XhUserCell: XhUserCell
  },
  filters: {
    detail: function detail(data) {
      if (data.status == 2) {
        return data.user_id_info.length + '人或签';
      } else if (data.status == 3) {
        return data.user_id_info.length + '人会签';
      } else if (data.status == 1) {
        return '负责人主管';
      } else if (data.status == 4) {
        return '上一级审批人主管';
      }
    },
    step: function step(index) {
      return '第' + Nzhcn.encodeS(index) + '级';
    },
    contentFilters: function contentFilters(array) {
      return array.map(function (item) {
        return item.realname;
      }).join('、');
    }
  },
  props: {
    // CRM类型
    types: {
      type: String,
      default: ''
    },
    // 办公审批 传ID
    typesId: {
      type: [String, Number],
      default: ''
    }
  },
  data: function data() {
    return {
      form: {
        name: ''
      },
      rules: {
        name: [{ required: true, message: '审批人不能为空', trigger: 'blur' }]
      },
      // 审核信息 config 1 固定审批 0 授权审批
      examineInfo: {},
      draftUser: null
    };
  },

  computed: {},
  mounted: function mounted() {
    this.getDetail();
  },

  methods: {
    getDetail: function getDetail() {
      var _this = this;

      var reqeust = {
        oa_examine: oaCreateExamineFlowAPI,
        crm_contract: crmExamineStepAPI,
        crm_invoice: crmExamineStepAPI,
        crm_receivables: crmExamineStepAPI
      }[this.types];
      //
      var params = {};
      if (this.types == 'oa_examine') {
        params.types = 'oa_examine';
        params.action = 'save';
        params.types_id = this.typesId;
        // params.types_id = this.typesId,
      } else {
        params.id = this.typesId;
        params.categoryType = {
          crm_contract: 1,
          crm_receivables: 2,
          crm_invoice: 3
        }[this.types]; // 1 合同 2 回款 3 发票
        params.types = this.types;
      }
      reqeust(params).then(function (res) {
        _this.examineInfo = res.data || {};
        if (_this.examineInfo.config == 0 && _this.examineInfo.examine_user) {
          _this.draftUser = {
            realname: _this.examineInfo.examine_user[0].realname,
            id: _this.examineInfo.examine_user[0].id
          };
          _this.form.name = _this.examineInfo.examine_user[0].realname;
          _this.$emit('value-change', _extends({}, _this.examineInfo, { // 审批类型
            value: [_this.draftUser] // 审批信息
          }));
        } else {
          _this.form.name = '';
          _this.draftUser = null;
          _this.$emit('value-change', _extends({}, _this.examineInfo, { // 审批类型
            value: [] // 审批信息
          }));
        }
      }).catch(function () {});
    },
    validateField: function validateField(result) {
      var _this2 = this;

      if (this.examineInfo.config == 0) {
        // 授权审批人 需要验证关联人
        this.$refs.form.validate(function (valid) {
          if (valid) {
            result(true); // 成功回调
          } else {
            // 提示第一个error
            for (var index = 0; index < _this2.$refs.form.fields.length; index++) {
              var ruleField = _this2.$refs.form.fields[index];
              if (ruleField.validateState == 'error') {
                _this2.$message.error(ruleField.validateMessage);
                break;
              }
            }
            result(false);
          }
        });
      } else {
        result(true); // 成功回调
      }
    },

    // 字段的值更新
    fieldValueChange: function fieldValueChange(data) {
      if (data.value.length) {
        this.draftUser = data.value[0];
        this.form.name = this.draftUser.id;
      } else {
        this.draftUser = null;
        this.form.name = '';
      }
      this.$emit('value-change', _extends({}, this.examineInfo, { // 审批类型
        value: data.value // 审批信息
      }));
      this.$refs.form.validateField('name');
    }
  }
};